import { useTheme } from '@adsk/alloy-react-styles';

import { Color } from '../consts';

export const useStatusColorToken = (color: Color): string | undefined => {
  const theme = useTheme();
  return theme.tokens?.component?.statusColorIndicator?.colors?.[color];
};
